<template>
  <div class="dataset-delete-confirm-dailog dialog col-block width-full">
    <div class="information-container col-block">
      <div class="information" v-html="$t('DIALOG.datasetArchiveConfirm.___info01')"></div>
      <div class="information" v-html="$tc('DIALOG.datasetArchiveConfirm.___info02', shares.length, { count: shares.length })"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="table-container col-block width-full">
      <div class="custom-table" :class="{ 'auto-height': true }">
        <div
          v-if="tableWidths"
          class="table-field col-block grab-container"
          :style="{ width: tableWidths.reduce((s, c) => s + c.value, 0) + 'px' }"
          @mousedown.left="e => boardEvent('board1', e, [boardStart])"
          @mousemove="e => boardEvent('board1', e, [boardMove])"
          @mouseout="e => boardEvent('board1', e, [boardMove])"
          @mouseup.left="e => boardEvent('board1', e, [boardEnd])"
        >
          <!-- line -->
          <div class="grab-line x min" :style="lineData.x.min && lineData.x.min.display ? { left: lineData.x.min.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x max" :style="lineData.x.max && lineData.x.max.display ? { left: lineData.x.max.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x main" :style="lineData.x.main && lineData.x.main.display ? { left: (lineData.x.main.base + lineData.x.main.grab) + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x custom" :style="lineData.x.custom && lineData.x.custom.display ? { left: lineData.x.custom.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y min" :style="lineData.y.min && lineData.y.min.display ? { top: lineData.y.min.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y max" :style="lineData.y.max && lineData.y.max.display ? { top: lineData.y.max.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y main" :style="lineData.y.main && lineData.y.main.display ? { top: (lineData.y.main.base + lineData.y.main.grab) + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y custom" :style="lineData.y.custom && lineData.y.custom.display ? { top: lineData.y.custom.value + 'px', display: 'block' } : {}"></div>
          <!-- /line -->
          <div class="table-container col-block">
            <div class="thead">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                  :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                  @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.sortValue || option.value)"
                >
                  <span class="ellipsis">{{ option.title }}</span>
                  <template v-if="option.sortMap !== null">
                    <div :style="{ width: '5px' }"></div>
                    <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                  </template>
                  <div
                    v-if="index + 1 > staticTableWidths[0].length && tableOptions[index + 1 + staticTableWidths[1].length]"
                    class="grab-box grab-x"
                    :class="{ grabbing: boardData['board1'].grabID === index }"
                    :grab-id="index"
                    :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                    :grab-x-min="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                    :grab-x-max="tableWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - staticTableWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - staticTableWidths[1].reduce((s, c) => s + c, 0) + '*'"
                    :grab-x-custom="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div ref="custom-table-scroll" class="table-group-container col-block width-full">
            <div class="col-block">
              <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
                <div class="tbody">
                  <div class="tr group row-block" :class="{ selected: group.datas.some(data => (selectedTableData || {}).id === data.id) }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                    <a class="container-block row-block">
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template>
                          <span
                            :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                            :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                          ></span>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                    </a>
                  </div>
                  <div class="tr col-block" :class="{ selectable: false, selected: (selectedTableData || {}).id === data.id }" v-for="(data, dindex) in group.datas" :key="dindex">
                    <a class="container-block row-block" :style="{ flex: 1 }" @click="e => false && (selectedTableData = data)">
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(data[option.value], dindex, data)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template>
                          <span
                            :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                            :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                          ></span>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="alert-button circle-button" @click="e => $emit('changeModal', {}, true)">
        <span>{{ $t('COMMON.button.___delete') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import customGrab from '../../mixins/customGrab.vue'
import responsitive from '../../mixins/responsitive.vue'
import { groupBy, sortData } from '../../constants/global/util'
import { datasetPermissionMap } from '../../constants/global/data'

export default {
  mixins: [
    customGrab,
    responsitive
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [
        [
        ],
        [
          127
        ]
      ],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'scrollState'
    ]),
    tableDatas () {
      let tableDatas = [...this.shares]
      tableDatas = sortData(
        tableDatas,
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      if (!['private'].includes(this.communityPermission)) {
        tableDatas = [
          {
            id: -1,
            user: {
              title: this.$t('DIALOG.datasetDeleteConfirm.table.data.___user')
            },
            permission: this.communityPermission
          },
          ...tableDatas
        ]
      }
      tableDatas = groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      return tableDatas
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    // static
    tableOptions () {
      return [
        {
          title: this.$t('DIALOG.datasetDeleteConfirm.table.title.___accectedUserID'),
          value: '_USERID',
          display: (_, __, data) => {
            let user = data.user
            return user ? ([user.title, user.first_name, user.last_name].filter(x => x).join(' ') + ' (' + [user.email, (user.organization || user.division ? [user.organization, user.division].filter(x => x).join(' ') : '')].filter(x => x).join(', ') + ')').replace(/ \(\)$/, '') : user
          },
          sortMap: data => {
            let user = data.user
            return user ? ([user.title, user.first_name, user.last_name].filter(x => x).join(' ') + ' (' + [user.email, (user.organization || user.division ? [user.organization, user.division].filter(x => x).join(' ') : '')].filter(x => x).join(', ') + ')').replace(/ \(\)$/, '') : user
          }
        },
        {
          title: this.$t('DIALOG.datasetDeleteConfirm.table.title.___permission'),
          value: 'permission',
          display: value => this.$t((datasetPermissionMap[value] || {}).title)
        }
      ]
    },
    // param
    communityPermission () {
      return this.param.communityPermission || 'private'
    },
    shares () {
      return this.param.shares || []
    }
  },
  watch: {
    // data
    'selectedTableData' (nv, ov) {
      if (nv !== ov && JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.selectedTableData = nv ? JSON.parse(JSON.stringify(nv)) : null
      }
    },
    // table
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    }
  },
  methods: {
    // table
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      window.dispatchEvent(new Event('scroll'))
      let tableWidth = Math.min(windowWidth - (20 * 2), 912) - (22 * 2) - (this.scrollState.height ? this.scrollbarSize : 0)
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        1,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableWidths = tableWidths
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
    },
    // grab
    boardResponse (id, type) {
      return {
        'board1': {
          'start': boardData => {
            this.sort.disabled = true
          },
          'move': boardData => {
            if (this.boardType['board1'] === 'grab') {
              let grabID = this.boardData[id].grabID
              let tableWidths = [...this.tableWidths]
              let result = boardData.grabX - boardData.baseX
              let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
              tableWidths.forEach((_, i) => {
                if (i === grabID) {
                  tableWidths[i].grab = result
                } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase))
                }
              })
              this.tableWidths = tableWidths
            }
          },
          'end': boardData => {
            let grabID = this.boardData[id].grabID
            let tableWidths = [...this.tableWidths]
            let result = boardData.grabX - boardData.baseX
            let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
            tableWidths.forEach((_, i) => {
              tableWidths[i].grab = 0
              if (i === grabID) {
                tableWidths[i].value += result
              } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase)
              }
            })
            this.tableWidths = tableWidths
            setTimeout(() => { this.sort.disabled = false })
          }
        }
      }[id][type]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/datasetDeleteConfirm.vue